import React from 'react';
import store from '../../../../Store'
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {
    setDefaultPlanForm, setSiteId
} from "./PlanForm-Action";
import createPlan from "../../../../ajax/actions/hosting-plan/plan_post";
import getPlans from "../../../../ajax/actions/hosting-plan/plan_get";

class PlanFormWorker extends React.Component {

    constructor(props) {
        super(props);
        store.dispatch(getPlans());
        store.dispatch(setSiteId(this.props.match.params.id))
        store.dispatch(setDefaultPlanForm())
    }

    componentDidUpdate(prev) {
        let {dispatchAPI} = this.props;
        if (dispatchAPI) {
            if (!prev.dispatchAPI) {
                store.dispatch(createPlan(this.props.match.params.id, this.props.match.params.org_id))
            }

        }
    }

    render() {
        return null
    }
}

function mapStateToProps(state) {
    let {planForm, createPlan, getSite} = state;
    let {dispatchAPI, mode, payload} = planForm.data;

    return {planForm, createPlan, dispatchAPI, mode, payload, getSite};
}

export default withRouter(connect(mapStateToProps)(PlanFormWorker));